import filtersTable from './filters-table.json';

const en = {
  title: 'Saved Filters',
  description: 'Saved Filters description',
  filtersTable,
};

export default en;
